import loginTitleLayoutType from '../constants/login-title-layout'
import loginLayoutType from '../constants/login-layout'


export const appsProps = {
    aa: {
        appValue: 'AAG',
        banner: '/img/RBC_main_login_background.jpg',
        frenchInfo: false,
        loginLayout: loginLayoutType.DEFAULT,
        loginTitle: 'aag.loginTitle',
        loginUrl: 'aa',
        logo: '/img/rbccm_logo_en.svg?url',
        logoFr: '/img/rbccm_logo_fr.svg?url',
        welcomeHeaderDesc: 'aag.welcomeHeaderDesc',
        welcomeHeaderDescTop: 'aag.welcomeHeaderDescTop',
        welcomeHeaderTitle: 'aag.welcomeHeaderTitle',
    },
    analytics: {
        appValue: 'MATA',
        banner: '/img/analytics/analytics_background.jpg',
        footerHidden: true,
        frenchInfo: false,
        loginLayout: loginLayoutType.MATA,
        loginTitle: 'analytics.loginTitle',
        loginUrl: 'analytics',
        logo: '/img/rbccm_logo_en.svg?url',
        logoFr: '/img/rbccm_logo_fr.svg?url',
        requestAccess: true,
        welcomeHeaderDesc: 'analytics.welcomeHeaderDesc',
        welcomeHeaderDescTop: 'analytics.welcomeHeaderDescTop',
        welcomeHeaderTitle: 'analytics.welcomeHeaderTitle',
    },
    cnb: {
        appValue: 'CNB DX',
        banner: '/img/RBC_signin_cover_shot.jpg',
        footer: {
            footerCopyright: 'cnb.footerCopyright',
            footerVerbiage: 'cnb.footerVerbiage',
            privacyLink: 'cnb.privacyUrl',
            privacyPolicy: 'cnb.privacyPolicy',
            privacyText: 'cnb.privacyCNB',
            termsConditions: 'cnb.termsandConditions',
            termsConditionsUrl: 'cnb.termsandConditionsUrl',
            wrapperText: 'cnb.wrappertext'
        },
        frenchInfo: false,
        loginLayout: loginLayoutType.CENTER,
        loginTitle: 'cnb.loginTitle',
        loginUrl: 'cnb',
        logo: 'cnb.logo',
        logoArialLabel: 'cnb.ariaLabelLogo',
        textInputFilled: true
    },
    comq: {
        appValue: 'CAMConnect',
        banner: '/img/comq/comq_background.png',
        frenchInfo: true,
        loginLayout: loginLayoutType.LEFT_RIGHT,
        loginTitle: 'comq.loginTitle',
        loginUrl: 'comq',
        logo: '/img/rbccm_logo_en.svg?url',
        logoFr: '/img/rbccm_logo_fr.svg?url',
        welcomeHeaderDesc: ' ',
        welcomeHeaderLogo: '/img/comq/comq_logo_en.svg?url',
        welcomeHeaderLogoFr: '/img/comq/comq_logo_fr.svg?url',
        welcomeHeaderTitle: ' '
    },
    main: {
        appValue: '',
        banner: '/img/RBC_main_login_background.jpg',
        frenchInfo: false,
        loginLayout: loginLayoutType.DEFAULT,
        loginTitle: 'main.loginTitle',
        loginUrl: '',
        logo: '/img/rbccm_logo_en.svg?url',
        logoFr: '/img/rbccm_logo_fr.svg?url',
        requestAccess: true,
        welcomeHeaderDesc: 'welcomeHeaderDescGeneral',
        welcomeHeaderDescTop: 'welcomeHeaderDescGeneralTop',
        welcomeHeaderTitle: 'welcomeHeaderTitleGeneral'
    },
    mfd: {
        appValue: 'RBC Money Funds Direct',
        banner: '/img/cacheMatrix/CacheMatrix-Back.png',
        frenchInfo: true,
        informationLink: 'https://www.rbccm.com/mfdbrochure',
        informationLinkName: 'mfd.informationLinkName',
        loginLayout: loginLayoutType.LEFT_RIGHT,
        loginTitle: 'mfd.loginTitle',
        loginTitleLayoutType: loginTitleLayoutType.ALTERNATIVE,
        loginUrl: 'mfd',
        logo: '/img/rbccm_logo_en.svg?url',
        logoFr: '/img/rbccm_logo_fr.svg?url',
        welcomeHeaderDesc: 'mfd.welcomeHeaderDesc',
        welcomeHeaderDescTop: 'mfd.welcomeHeaderDescTop',
        welcomeHeaderTitle: 'mfd.welcomeHeaderTitle',
        welcomeHeaderTitleItalic: 'mfd.welcomeHeaderTitleItalic'
    },
    rbcdx: {
        appValue: 'RBCDX V2',
        banner: '/img/rbcdx/rbcdx_background.png',
        frenchInfo: false,
        loginLayout: loginLayoutType.RBCDX,
        loginTitle: 'rbcdx.loginTitle',
        loginUrl: 'rbcdx',
        logo: '/img/rbccm_logo_en.svg?url',
        logoFr: '/img/rbccm_logo_fr.svg?url',
        qrCode: '/img/rbcdx/rbcdx_qrCode.svg?url',
        welcomeHeaderDesc: 'rbcdx.welcomeHeaderDesc',
        welcomeHeaderLogo: 'https://www.sterbccm.com/assets/rbccm/images/dx-logo.svg?url',
        welcomeHeaderLogoFr: '/img/rbcdx/dx-logo_fr.svg?url',
        welcomeHeaderTitle: 'rbcdx.welcomeHeaderTitle',
    }
}

export const appEnum = {
    'aa': 'AAG',
    'aag': 'AAG',
    'analytics': 'MATA',
    'cnb': 'CNB DX',
    'hedgex': 'HedgeX',
    'mfd': 'RBC Money Funds Direct',
    'rbcdx': 'RBCDX V2',
    
}

export const loginUrls = Object.values(appsProps).map(app => `/${app.loginUrl}/login`)
